import React from 'react'

import Logo from '../../../../assets/images/Logotipo.png'

import './Styles.css'

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="content">
        <img className="logo" src={Logo} alt="logo" />
      </div>
    </div>
  )
}

export default Navbar
